module.exports = __webpack_public_path__ + "static/media/4.a3ceef26.jpg";